// extracted by mini-css-extract-plugin
export default {"aboutus-container":"AboutUs_aboutus-container__azMYI","ending-p":"AboutUs_ending-p__ICht0"};